import { render, staticRenderFns } from "./ChannelSelect.vue?vue&type=template&id=133bc65c&scoped=true"
import script from "./ChannelSelect.vue?vue&type=script&lang=js"
export * from "./ChannelSelect.vue?vue&type=script&lang=js"
import style0 from "./ChannelSelect.vue?vue&type=style&index=0&id=133bc65c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133bc65c",
  null
  
)

export default component.exports